import themeVariables from "@/config/theme/themeVariable";
import Link from "next/link";
import Image from "next/image";
import { BLUR_URL, images } from "@/utils/images";
import { BlogPost } from "@/config/endpoint/interface/blogs";
import { useLanguage } from "@/hooks/useLanguage";
import { useTranslation } from "@/hooks/useTranslation";
import { Clock4, Clock5 } from "lucide-react";



export default function BlogCard({ blog }: { blog: BlogPost }) {
  const { language } = useLanguage();
  const { t } = useTranslation();
  
  return (
    <Link href={`/${language}/blogs/${blog.id}`}>
      <div className="bg-white rounded-xl overflow-hidden duration-300 max-w-4xl cursor-pointer group">
        <div className="flex flex-col md:gap-3 md:flex-row">

          <div className="w-full md:w-56 relative order-1 md:order-2 overflow-hidden p-4 flex items-center">
            <div className="h-52 md:h-44 relative overflow-hidden rounded-xl w-full">
              <Image 
                src={blog.thumbnail_url} 
                alt={blog.title[language]}
                fill
                className="object-cover group-hover:scale-105 transition-transform duration-300 rounded-xl"
                placeholder="blur"
                blurDataURL={BLUR_URL}
                sizes="(max-width: 768px) 100vw, 224px"
              />
            </div>
          </div>
          
          <div className="flex-1 p-3 md:p-5 order-2 md:order-1">
            <div className="text-gray-500 text-sm mb-3 md:mb-4">
              {new Date(blog.created_at).toLocaleDateString()}
            </div>
            
            <h2 className="text-gray-900 text-xl md:text-2xl font-bold mb-3 leading-tight group-hover:text-gray-600 transition-colors duration-150">
              {blog.title[language]}
            </h2>
            
            <p className="text-gray-600 text-sm md:text-base mb-3 md:mb-5 leading-relaxed">
              {blog.subtitle[language]}
            </p>
            
            <div className="flex flex-wrap items-center gap-4 md:gap-6 text-gray-500 text-sm">
              <div className="flex items-center gap-2">
                <Clock4 className="w-[18px] h-[18px] fill-gray-500 stroke-white"/>
                <span>{blog.read_time} {t('min_read')}</span>
              </div>
              
              {/* <div className="flex items-center gap-2">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                  <path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" />
                </svg>
                <span>{blog.views.toLocaleString()} {t('views')}</span>
              </div> */}
              
              <div className="ml-auto flex items-center gap-1 flex-wrap">
                {blog.tags[language].map((tag: string) => (
                  <span key={tag} className={themeVariables.badge.light}>{tag}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  )
}
